module.exports = __webpack_public_path__ + "static/media/monograma_cid.90553735.png";